/**
 * Service: comboApi
 */
angular.module('acme.common.service.comboApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('ComboApiService', [ '$http', 'QueryStringBuilderFactory',  function ($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/combo';
        this.templates.service = this.service + '/event/templates';
        return this;
      },
      templates : {
        service: '',

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: props
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/' + id
          });
        },

        list: function(props) {
          var q = '';
          
          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['page', 'pageSize', 'sortField', 'sortDirection', 'summary', 'search']
              }
            });

            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        get: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        }
      }

    };

}]);